import React, { useEffect, useState, createContext, useContext } from "react";
import Card from "@mui/material/Card";
import { useSearchParams } from "react-router-dom";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useLocation } from "react-router-dom";
import SearchStringOrIntReq5 from "../../../../Classes/Models/Requests/SearchStringOrIntReq";
import SessionsApi from "../../../../Classes/API/Administration/SessionsApi";
import PackageDetailsCard from "./PackageDetailsCard";
import SessionsTable from "../../SessionsTable";
import AddSessionsToPackage from "./AddSessionsToPackage";
import PackageStatistics from "./PackageStatistics";
import "./PackageDetails.scss";
import PostPaid from "./PostPaid";
import NotesAndStartDate from "./NotesAndStartDate";
import AccountingApi from "Classes/API/AccountingApi";
import SearchStringOrIntReq from "Classes/Models/Requests/StringIntSearchReq";
import { UserContext } from "App";
import Swal from "sweetalert2";
import PayFromBalanceReq from "Classes/Models/Requests/Accounting/PayFromBalanceReq";
import PackageSessionsTable from "./PackageSessionsTable";
import { getTableRecordsForPackage } from "Classes/API/ReceiptsApi";
import ReceiptsTable from "layouts/receipts/receipts-table";

const index = () => {
  const CurrentUser = useContext(UserContext);
  let { state } = useLocation();
  const [iIsLoaded, setIsLoaded] = useState(false);
  const [packageData, setPackageData] = useState({});
  const [showSessions, setShowSessions] = useState(false);
  const [showAddSessions, setShowAddSessions] = useState(false);
  const [userBalance, setUserBalance] = useState(null);
  const [receipts, setReceipts] = useState();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    async function fetchReceipts() {
      try {
        const filters = {};

        const page = searchParams.get("page");
        if (page) filters.page = page;

        const response = await getTableRecordsForPackage(packageData.id, filters);
        setReceipts(response);
      } catch (error) {
        console.error("Error fetching receipts:", error);
      }
    }

    if (packageData && packageData.id) fetchReceipts();
  }, [searchParams, packageData]);

  const getPackageData = async (id) => {
    let req = new SearchStringOrIntReq5();
    req.SearchInt = id;
    let res = await SessionsApi.GetPackageById(req);
    if (res.status == "Success") {
      setPackageData(res.data);
    }
  };

  const getUserBalance = async (id) => {
    let req = new SearchStringOrIntReq();

    console.log(state);
    req.SearchInt = id;
    let res = await AccountingApi.GetCurrentUserBalance(req);
    if (res.status == "Success") {
      setUserBalance(res.data);
    } else {
      Swal.fire({
        title: "Error",
        text: "Payment failed: " + res.message,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  useEffect(async () => {
    if (!iIsLoaded) {
      await getPackageData(state.pkg.id);
    }
  }, [iIsLoaded]);

  useEffect(async () => {
    if (state?.pkg?.getPatient?.getUser?.id != null) {
      await getUserBalance(state.pkg.getPatient.getUser.id);
    }
    if (state?.pkg?.id != null) {
      if (packageData?.getPatient?.getUser?.id != null) {
        await getUserBalance(packageData?.getPatient?.getUser?.id);
      }
    }
  }, [packageData, state]);

  useEffect(() => {
    if (Object.keys(packageData).length > 0) {
      setIsLoaded(true);
    } else {
      setIsLoaded(false);
    }
  }, [packageData]);

  useEffect(() => {
    if (showSessions || showAddSessions) {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [showSessions, showAddSessions]);

  if (!iIsLoaded && Object.keys(packageData).length == 0) {
    return <div>Loading Contract Data...</div>;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PackageDetailsCard
        Package={packageData}
        setIsLoaded={setIsLoaded}
        setShowSessions={setShowSessions}
        ShowSessions={showSessions}
        setShowAddSessions={setShowAddSessions}
        ShowAddSessions={showAddSessions}
        userBalance={userBalance}
      />

      <NotesAndStartDate Package={packageData} setIsLoaded={setIsLoaded} />
      {packageData.postPaid && <PostPaid Package={packageData} setIsLoaded={setIsLoaded} />}
      <PackageStatistics Package={packageData} />
      {showSessions && (
        <PackageSessionsTable
          packageData={packageData}
          setIsLoaded={setIsLoaded}
          setPackageData={setPackageData}
        />

        // <SessionsTable
        //   accountingSessions={packageData.getAccountingSessions}
        //   setIsLoaded={setIsLoaded}
        //   deleteAllSessions={deleteAllSessions}
        //   refundSession={refundSession}
        //   deleteAccountingSession={deleteAccountingSession}
        // />
      )}
      {showAddSessions && <AddSessionsToPackage Package={packageData} />}

      {receipts && (
        <Card sx={{ height: "100%", boxShadow: !false && "none", marginBottom: "2em" }}>
          <ReceiptsTable
            receipts={receipts.items}
            totalCount={receipts.totalCount}
            pageNumber={receipts.pageNumber}
            pageSize={receipts.pageSize}
          />
        </Card>
      )}
    </DashboardLayout>
  );
};
export default index;
